export class ScrollBlocker {
    static noScrollClass = 'no-scroll';

    static AddTo(to) {
        jQuery(to).addClass(ScrollBlocker.noScrollClass);
    }

    static RemoveFrom(from) {
        jQuery(from).removeClass(ScrollBlocker.noScrollClass)
    }
}